<main class="container-bg">
  <form [formGroup]="form">
    <h2 class="m-b-30">Editar Usuarios</h2>
    <section class="container-form">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Nombre </mat-label>
        <input matInput formControlName="firstName" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Apellido </mat-label>
        <input matInput formControlName="lastName" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Numero </mat-label>
        <input matInput formControlName="phone" type="number" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>RUT</mat-label>
        <input matInput formControlName="rut" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" />

      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Rol / Roles</mat-label>
        <mat-select formControlName="roles">
          <mat-option value="ejecutivo"> Ejecutivo </mat-option>
          <mat-option value="admin"> Administrador </mat-option>
          <mat-option value="Jefe"> Jefe </mat-option>
        </mat-select>
      </mat-form-field>
      <!-- <mat-form-field appearance="outline" class="w-100" color="primary">
        <mat-label>Contraseña</mat-label>
        <input
          matInput
          [type]="hide ? 'password' : 'text'"
          formControlName="password"
        />
        <span
          style="
            border: 0px;
            background: transparent;
            cursor: pointer;
            padding-right: 5px;
          "
          matSuffix
          (click)="hide = !hide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide"
        >
          <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
        </span>

      </mat-form-field> -->
      <!-- <mat-form-field appearance="outline" class="w-100" color="primary">
        <mat-label>Repita Contraseña</mat-label>
        <input
          matInput
          [type]="hide ? 'password' : 'text'"
          formControlName="confirmPassword"
        />
        <span
          style="
            border: 0px;
            background: transparent;
            cursor: pointer;
            padding-right: 5px;
          "
          matSuffix
          (click)="hide = !hide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide"
        >
          <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
        </span>
      </mat-form-field> -->
    </section>
    <button
      mat-flat-button
      color="primary"
      class="w-50"
      [disabled]="!form.valid"
    >
      Cambiar
    </button>
  </form>
</main>
